import { render, staticRenderFns } from "./FaQ.html?vue&type=template&id=f035d7f8&scoped=true&"
import script from "./FaQ.ts?vue&type=script&lang=ts&"
export * from "./FaQ.ts?vue&type=script&lang=ts&"
import style0 from "./FaQ.css?vue&type=style&index=0&id=f035d7f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f035d7f8",
  null
  
)

export default component.exports